import { apiSlice } from '@/api'

export const reportsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTrafficChannels: builder.query({
      query: (arg) => {
        const { start_date, end_date } = arg
        return {
          url: 'api/v2/reports/traffic/channels',
          method: 'GET',
          params: { start_date, end_date }
        }
      },
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [...result.map(({ id }) => ({ type: 'Reports', id })), 'Reports']
          : ['Reports']
      // providesTags: (result) =>
      //   result
      //     ? [...result.map(({ id }) => ({ type: 'Reports', id })), 'Reports']
      //     : ['Reports']
    }),
    getTrafficBuildings: builder.query({
      query: (arg) => {
        const { start_date, end_date } = arg
        return {
          url: 'api/v2/reports/traffic/buildings',
          method: 'GET',
          params: { start_date, end_date }
        }
      },
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [...result.map(({ id }) => ({ type: 'Reports', id })), 'Reports']
          : ['Reports']
      // providesTags: (result) =>
      //   result
      //     ? [...result.map(({ id }) => ({ type: 'Reports', id })), 'Reports']
      //     : ['Reports']
    }),
    getTrafficPartners: builder.query({
      query: (arg) => {
        const { start_date, end_date } = arg

        return {
          url: 'api/v2/reports/traffic/partners',
          method: 'GET',
          params: { start_date, end_date }
        }
      },
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [...result.map(({ id }) => ({ type: 'Reports', id })), 'Reports']
          : ['Reports']
      // providesTags: (result) =>
      //   result
      //     ? [...result.map(({ id }) => ({ type: 'Reports', id })), 'Reports']
      //     : ['Reports']
    }),
    getPersonsReports: builder.query({
      query: (arg) => {
        const { id, from, to } = arg

        return {
          url: `api/v2/persons/report/building/${id}`,
          method: 'GET',
          params: { from, to }
        }
      }
    }),
    getCarsReports: builder.query({
      query: (arg) => {
        const { id, from, to } = arg
        return {
          url: `api/v2/reports/cars/${id}`,
          method: 'GET',
          params: { from, to }
        }
      }
    })
  })
})

export const {
  useLazyGetTrafficBuildingsQuery,
  useLazyGetTrafficChannelsQuery,
  useLazyGetTrafficPartnersQuery,
  useLazyGetPersonsReportsQuery,
  useGetPersonsReportsQuery,
  useLazyGetCarsReportsQuery
} = reportsApi
